/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useRef, useEffect } from 'react';
import {
  Button,
  Grid,
  TextField,
  Switch,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import readXlsxFile from 'read-excel-file';
import styles from '../../../styles/Layout.module.css';
import api from '../../../service/axios/api';
import MyButton from '../../../components/button/MyButton';
import {
  cleanNumber,
  validateCpf,
  validateDocExtern,
  validateDocument
} from '../../../service/utils';
import TableCartaoEstoque from '../../../components/tables/premiados/TableCartaoEstoque';
import DisplayErrorDocument from './DisplayErrorDocument';
import Loading from '../../../components/loading/Loading';

const useStyles = makeStyles(() => ({
  myTextField: {
    backgroundColor: 'none',
    boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
    border: 'none',
    color: '#717171',
    fontWeight: 'bold',
    fontFamily: 'Open Sans'
  },
  text: {
    fontFamily: 'Open Sans',
    fontWeight: 'bold',
    color: '#717171'
  },
  mySwitch: {
    '&.MuiSwitch-colorPrimary.MuiSwitch-checked': {
      color: 'green'
    }
  },
  checked: {},
  switchBase: {
    color: '#fff',
    '&$checked': {
      color: '#41b490'
    },
    '&$checked + $track': {
      backgroundColor: '#41b490'
    }
  },
  track: {}
}));

// eslint-disable-next-line prettier/prettier
export default function UploadPlan({
  naoPassa,
  myFile,
  setMyfile,
  orders,
  refQtdCards,
  setRefQtdCards,
  proxys,
  setProxys,
  setOrders,
  setMsg,
  setLoad,
  contract,
  nf,
  setNf,
  boleto,
  setBoleto,
  paymentDate,
  setPaymentDate,
  isNew,
  orderName,
  setOrderName,
  nfComments,
  setNfComments,
  erros,
  setErros,
  setOk,

  
}) {

  const fileXls = useRef(null);
  const classes = useStyles();
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  

  const downloadModel = () => {
    const url =
      'https://epp-storage.s3.us-east-1.amazonaws.com/templates/Compra_estoque_com_proxy.xlsx';
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'comprarCartao_template'); // or any other extension
    document.body.appendChild(link);
    link.click();
  };


  
  useEffect(() => {
    if (myFile) {
      setLoading(true);
      
      readXlsxFile(myFile)
        .then(r => {
          const listaProxy = []
          r.forEach((row, idx) => {
            if (idx !== 0){
              if (row[0]) {
              listaProxy.push(row[0])
            }
            } 
          });
          
          
          if (listaProxy.length > 0) {
            setOrders(listaProxy);
          } else {
            cleanPlan();
          }
        
          
          setLoading(false);
        })
        .catch((error) => {
          console.error('Erro ao ler arquivo:', error);
          setLoading(false);
        });
    }
  }, [myFile]);

  useEffect(() => {
    if (orders.length > 0) {
      const proxysList = orders.map((o) => o);
      setProxys(proxysList);
    } else {
      setProxys([]);
    }
  }, [orders, setProxys]);


  const handleChangeBoleto = e => {
    if (e) {
      setBoleto(e);
      // setNf('NF');
    } else {
      setBoleto(e);
    }
  };

  const handleChangeNf = e => {
    setNf(e.target.value);
    /* if (e.target.value === 'ND') {
      setBoleto(false);
    } */
    if (e.target.value === 'NFND') {
      setOpenModal(true);
    }
  };

  const cleanPlan = () => {
    if (fileXls.current) {
      fileXls.current.value = '';
    }
    setMyfile(null);
    setOrders([]);
    setErros([]);
    setOk([]);
  };


  return (
    <div className="box-new-card">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <h6 className={styles.textBoxInform}>
          {t('newOrder.qtdCards.label')}
        </h6>

        {isNew && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: 10
            }}
          >
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">
                Tipo de documento
              </FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                row
                onChange={handleChangeNf}
                value={nf}
              >
                <FormControlLabel value="NF" control={<Radio />} label="NF" />
                <FormControlLabel
                  value="NFND"
                  control={<Radio />}
                  label="NF+ND"
                />
                {!api.currentUser.user.role.is_client && (
                  <FormControlLabel value="ND" control={<Radio />} label="ND" />
                )}
              </RadioGroup>
            </FormControl>

            <Grid item>
              {t('newOrder.qtdCards.ticket')}
              <Switch
                checked={boleto}
                onChange={e => handleChangeBoleto(e.target.checked)}
                classes={{
                  switchBase: classes.switchBase,
                  checked: classes.checked,
                  track: classes.track
                }}
              />
            </Grid>

            <Grid item>
              <MuiPickersUtilsProvider locale={locale} utils={DateFnsUtils}>
                <DatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label={t('newOrder.qtdCards.expirationDate')}
                  size="small"
                  format="dd/MM/yyyy"
                  value={paymentDate}
                  InputProps={{
                    readOnly: true,
                    style: {
                      borderRadius: '25px',
                      textAlign: 'center',
                      alignItems: 'center',
                      justifyContent: 'center',
                      maxWidth: '155px'
                    }
                  }}
                  onChange={date => setPaymentDate(date)}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </div>
        )}
      </div>

      {isNew && (
        <Grid
          container
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Grid item xs={5} style={{ marginTop: '15px', marginRight: '10px' }}>
            <TextField
              className={classes.text}
              variant="outlined"
              size="small"
              fullWidth
              placeholder={t('newOrder.qtdCards.orderName')}
              value={orderName}
              onChange={e => setOrderName(e.target.value)}
              InputProps={{
                classes: {
                  notchedOutline: classes.myTextField,
                  input: classes.text
                }
              }}
            />
          </Grid>

          <Grid item xs={5} style={{ marginTop: '15px', marginLeft: '10px' }}>
            <TextField
              className={classes.text}
              variant="outlined"
              size="small"
              fullWidth
              placeholder={t('newOrder.qtdCards.comments')}
              value={nfComments}
              onChange={e => setNfComments(e.target.value)}
              InputProps={{
                classes: {
                  notchedOutline: classes.myTextField,
                  input: classes.text
                }
              }}
            />
          </Grid>
        </Grid>
      )}

      <Grid
        container
        spacing={1}
        direction="row"
        style={{
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          paddingBottom: 10,
          marginTop: isNew ? 10 : 50,
          marginBottom: 50
        }}
      >
        <Grid item>
          <p className={styles.labelTitleResum}>
            {t('newOrder.qtdCards.qtdCards')}
          </p>
          <TextField
            type="number"
            className={classes.text}
            variant="outlined"
            size="small"
            value={refQtdCards}
            onChange={e => setRefQtdCards(e.target.value)}
            InputProps={{
              classes: {
                notchedOutline: classes.myTextField,
                input: classes.text
              }
            }}
          />
      
          {Number(refQtdCards) < orders.length && (
            <p style={{ color: 'red', paddingTop: '5px' }}>
              A quantidade solicitada é inferior à quantidade de cartões indicada na planilha
            </p>
          )}
        </Grid>




        <Grid item>
          <h6 className={styles.textBoxInform}>
            {t('newOrder.tranferPlan.label')}
          </h6>

          <Grid
            container
            spacing={1}
            direction="row"
            style={{ gap: 2, marginTop: 10 }}
          >
            <Grid item>
              <p
                className="label-planilhas"
                style={{ cursor: 'pointer' }}
                onClick={downloadModel}
              >
                <img
                  id="planilha"
                  src="../img/download.svg"
                  alt="Baixar template"
                  style={{ marginRight: '3px' }}
                  className="img-planilhas"
                />
               
              </p>
            </Grid>

            <Grid item>
              <p className="label-planilhas" style={{ cursor: 'pointer' }}>
                <img
                  id="planilha"
                  src="../img/upload.svg"
                  alt="Enviar planilha"
                  className="img-planilhas"
                  style={{ marginRight: '8px' }}
                  onClick={() => fileXls.current.click()}
                />
                {t('newOrder.tranferPlan.planAwarded')}

                {myFile && (
                  <Button
                    variant="outlined"
                    size="small"
                    style={{
                      height: 20,
                      color: 'red',
                      marginLeft: 15,
                      borderColor: 'red'
                    }}
                    onClick={cleanPlan}
                  >
                    LIMPAR
                  </Button>
                )}
              </p>

              <input
                ref={fileXls}
                type="file"
                accept=".xlsx,.xls"
                style={{
                  opacity: 0,
                  position: 'absolute',
                  pointerEvents: 'none'
                }}
                onChange={() => setMyfile(fileXls.current.files[0])}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>


      {myFile && orders.length > 0 && (
        <Grid item xs={11}>
          <TableCartaoEstoque
            setOrders={setOrders}
            orders={orders}
            totalPages={1}
            page={1}
            itens={10}
            isNew={isNew}
          />
        </Grid>
      )}

      <Loading open={loading} msg="Validando documentos..." />

      <Dialog open={openModal}>
        <DialogTitle>Importante</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Você selecionou a opção de emissão de NF + ND, com isso receberá uma
            Nota Fiscal com os valores de Serviços e uma Nota de Débito com os
            valores de repasse. Confirma?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MyButton
            style={{
              width: 120,
              height: 40,
              borderRadius: 10,
              backgroundColor: '#657588'
            }}
            onClick={() => {
              setNf('NF');
              setOpenModal(false);
            }}
            label="NÃO"
          />
          <MyButton
            style={{
              width: 120,
              height: 40,
              borderRadius: 10
            }}
            onClick={() => setOpenModal(false)}
            label="SIM"
          />
        </DialogActions>
      </Dialog>

      <Dialog
        onClose={() => setErrorModal(false)}
        open={errorModal}
        fullWidth
        maxWidth="md"
      >
        <DisplayErrorDocument errors={erros} setModalError={setErrorModal} />
      </Dialog>
    </div>
  );
}
